var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header-wrapper",class:{ 'border-bottom': !_vm.isHomePage }},[_c('div',{staticClass:"header container"},[_c(_vm.headerComponent,{tag:"component"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }